<template>
	<div class="page-container style-dark">
		<div class="block header">
			<div class="container">
				<div class="row">
					<div class="col-lg-8 col-xs-12">
						<h1>
							{{ $route.name }}
						</h1>
					</div>
				</div>
			</div>
		</div>

		<div v-if="isRegistrar" class="container alert">
			<div class="row">
				<div class="col-lg-12">
					<div class="tile">
						<div class="flash-alert">
							<div>Вы {{ fullName }} ({{ id }}). IP адрес {{ ip }} - {{ date }} </div>
							<div>У вас {{ security }} защиты!</div>

							<div>
								01.12.2023 доступ в кабинет регистратора без средств защиты и идентификации ЕСИА
								<a :href="logoutUrl" @click.stop="logout">
									(ссылка)
								</a>
								будет ограничен.
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="container activity">
			<div class="row">
				<div class="col-lg-4 visible-lg">
					<VerticalMenu :routes="routes" />
				</div>
				<RouterView />
			</div>
		</div>
	</div>
</template>

<script>
import { deleteTokens, getFullName, } from '@/auth';
import VerticalMenu from './VerticalMenu.vue';

export default {
	name: 'ContentApp',
	components: {
    VerticalMenu
},
	props: ["routes", "ipData"],
	data() {
		return {
			isRegistrar: false,
			logoutUrl: null,
			alert: '',
			security: '',
			id: '',
			fullName: '',
			ip: '',
			date: new Date().toLocaleString('ru-RU'),
		}
	},
	created() {
		this.fullName = getFullName()

		// const role = getUserRole()
		// const ipData = this.ipData ?? {}

		// if ((role === 'registrar')) {
		// 	this.isRegistrar = true

		// 	this.security = ipData.has_security ? 'ЕСТЬ средства' : 'НЕТ средств'
		// 	this.has_security = ipData.has_security
		// 	this.ip = ipData.ip
		// 	this.id = getUsername()

		// 	this.logoutUrl = getLogoutUrl('/esia-redirect');
		// }
	},
	methods: {
		logout: function () {
			deleteTokens();
		},
	},
}
</script>